import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/admin/ProtectedRoute";

// Page imports
import WelcomeCalculatorIntroduction from "pages/welcome-calculator-introduction";
import MaterialInputWizard from "pages/material-input-wizard";
import CalculationProcessing from "pages/calculation-processing";
import ResultsDashboard from "pages/results-dashboard";
import ExportSummary from "pages/export-summary";

// Admin page imports
import AdminLogin from "pages/admin/AdminLogin";
import AdminDashboard from "pages/admin/AdminDashboard";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Calculator Routes */}
          <Route path="/" element={<WelcomeCalculatorIntroduction />} />
          <Route path="/welcome-calculator-introduction" element={<WelcomeCalculatorIntroduction />} />
          <Route path="/material-input-wizard" element={<MaterialInputWizard />} />
          <Route path="/calculation-processing" element={<CalculationProcessing />} />
          <Route path="/results-dashboard" element={<ResultsDashboard />} />
          <Route path="/export-summary" element={<ExportSummary />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;